export default "__VITE_ASSET__aa975307__"